import { stepConnectorClasses } from "@mui/material/StepConnector";

const transitionDelay = 5;

interface stylesInterface {
  transitionDelay: number;
  visible: boolean;
}

export const CustomConnectorstyles = (props: stylesInterface) => {
  return {
    [`&.${stepConnectorClasses.alternativeLabel}.failed-step`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "var(--background-warning)",
      }
    },
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "var(--secondary-color)",
        width: `100%`,
      },
      [`& .${stepConnectorClasses.lineVertical}`]: {
        backgroundColor: "var(--secondary-color)",
        width: `3px`,
        height: "200%",
        top: "-10px",
        left: "10px",
        position: "relative",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "var(--secondary-color)",
        width: `100%`,
      },
      [`& .${stepConnectorClasses.lineVertical}`]: {
        backgroundColor: "var(--secondary-color)",
        width: `3px`,
        height: "200%",
        top: "-10px",
        left: "10px",
        position: "relative",
      },
    },
    [`& .${stepConnectorClasses.lineHorizontal}`]: {
      height: 3,
      border: 0,
      backgroundColor: "grey",
      borderRadius: 1,
      width: `${props.visible ? 100 : 0}%`,
      transition: `width 0.25s ${transitionDelay}s`,
    },
    [`& .${stepConnectorClasses.lineVertical}`]: {
      width: 3,
      backgroundColor: "grey",
      top: "-10px",
      left: "11px",
      position: "relative",
      height: `${props.visible ? 200 : 0}%`,
      transition: `height 0.25s ${transitionDelay}s`,
    },
  }
};
